export default __webpack_public_path__ + "static/media/cloud-desktop-block1.e9fb927d.png";